import * as React from "react";
const SvgBubble = `<svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153 74" width="512" height="248">
<title>New Project</title>
<style>
.s0 { fill: #f39c12 } 
</style>
<path id="Shape 5" class="s0" d="m4 34.5c0-13.5 11-24.5 24.5-24.5h97c13.5 0 24.5 11 24.5 24.5 0 13.5-11 24.5-24.5 24.5h-97c-13.5 0-24.5-11-24.5-24.5z"/>
<path id="Shape 4" class="s0" d="m102.2 25.5l-25.4 44-25.3-44z"/>
</svg>`;
export default SvgBubble;
